module.exports = "<my-commande-create-form my-commande=\"$$commande.data.myCommande\"\n  my-searched-wagons=\"$$commande.data.mySearchedWagons\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-commande-create-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/commande/templates/new.html
// module id = 1554
// module chunks = 0